import React from 'react';
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

interface LoadingBackdropProps {
  open: boolean;
  message?: string;
  size?: number;
  backgroundColor?: string;
}

const LoadingBackdrop: React.FC<LoadingBackdropProps> = ({
  open,
  message = 'Đang xử lý...',
  size = 60,
  backgroundColor = 'rgba(0, 0, 0, 0.7)',
}) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor,
      }}
      open={open}
    >
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        gap: 2 
      }}>
        <CircularProgress color="inherit" size={size} />
        <Typography variant="h6" sx={{ color: 'white', fontWeight: 500 }}>
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default LoadingBackdrop; 